var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"address-book-icon-btn",attrs:{"type":"button","aria-label":"Open address book"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"address-book-icon-btn__img",attrs:{"src":require("@/assets/icons/address-book-icon-nobg.svg"),"alt":"Address book"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }